import Vue from 'vue';
import teamMemberService from '../team_member';

const success = (response, context) => {
  $('.cancel').removeClass('disabled');
  $('.confirm').removeClass('disabled');
  swal('Deleted!', 'Your imaginary user has been deleted!', 'success');
  context.loading = false;
  teamMemberService.get(context);
};

// When the request fails
const failed = (error, context) => {
  if (error.response) {
    $('.cancel').removeClass('disabled');
    $('.confirm').removeClass('disabled');
    swal('Error!', error.response.data.msg, 'warning');
        // this.error = error.response.data.msg;
    toastr.error(error.response.data.msg);
    context.loading = false;
  }
};

export default (context, id) => Vue.$http.delete(`/team-members/${id}`).then((response) => {
  if (response && response.status === 200) {
    success(response, context);
  }
})
    .catch((error) => {
      failed(error, context);
    });



// WEBPACK FOOTER //
// ./src/app/services/account/deleteTeamMembers.js